module.exports = __webpack_public_path__ + "img/arrowsRed.eac0ed19.png";